import cn from 'classnames';
import React from 'react';
import './Tags.scss';

export interface TagProps {
  label: string;
  color: TagColorEnum;
}

// Weitere Farben müssen noch implementiert werden.
export enum TagColorEnum {
  Green = 'green',
  Yellow = 'yellow',
  Red = 'red',
  Grey = 'grey',
  /**
   * Teal marks a state that is neither present nor absent — a partial absence
   * (late arrival, left early). Matches the teal absence indicator of the
   * class view (`--absence-status-late-or-left-early`).
   */
  Teal = 'teal',
}

export const Tag: React.FC<TagProps> = ({ label, color }) => {
  return <span className={cn('tag', color)}>{label}</span>;
};
